import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useProducts } from '../context/ProductContext';
import { getProductUrl, parseProductId } from '../utils/product';

export default function ProductLegacyRedirect() {
  const { legacy } = useParams<{ legacy: string }>();
  const { getProductById, loadProduct } = useProducts();
  const [target, setTarget] = useState<string | null>(null);
  const productId = parseProductId(legacy);

  useEffect(() => {
    if (!legacy) return;

    if (!productId) {
      setTarget(getProductUrl(legacy));
      return;
    }

    const existing = getProductById(productId);
    if (existing) {
      setTarget(getProductUrl(existing.slug));
      return;
    }

    let cancelled = false;
    void loadProduct(productId).then((product) => {
      if (cancelled) return;
      setTarget(product ? getProductUrl(product.slug) : '/shop');
    });

    return () => {
      cancelled = true;
    };
  }, [legacy, productId, getProductById, loadProduct]);

  if (target) {
    return <Navigate to={target} replace />;
  }

  return (
    <div className="container empty-state">
      <p>Yönlendiriliyor...</p>
    </div>
  );
}
